import personTranslations from "./personTranslations";
import { courtTranslations } from "./courtTranslations";
import { opponentLawFirmTranslations } from "./opponentLawFirmTranslations";
import opposingPartyLegalEntityTranslations from "./opposingPartyLegalEntityTranslations";
import { objectivesLawFirmValues } from "./objectivesLawFirmTranslations";
import abstractCaseTranslations from "./abstractCaseTranslations";
import organizationTranslation from "./organizationTranslation";
import authorityTranslations from "./authorityTranslations";
import opposingLiabilityInsuranceTranslation from "./opposingLiabilityInsuranceTranslation";
import { legalRepresentativeTranslations } from "./legalRepresentativeTranslations";
import organizationEmailTranslations from "./organizationEmailTranslations";

const litigationCaseTranslations = {
  ...abstractCaseTranslations,
  advoAssistHearing: {
    label: "Advo Assist Termin",
  },
  opponentLawyer: personTranslations,
  referenceOpponentLawyer: {
    label: "Aktenzeichen Anwalt Gegenseite",
  },
  opponentLawFirm: opponentLawFirmTranslations,
  objectiveCommitted: {
    label: "Zielsetzung Gerichtsverfahren",
    values: {
      fulfillment: "Erfüllung",
      withdrawal: "Rücktritt",
      reduction: "Erstattung",
      compensation: "Schadensersatz",
      repair: "Nacherfüllung",
      replacement: "Ersatz",
      careerAndEmployment: "Karriere & Dienstverhältnis",
      moneyAndRefund: "Geld & Erstattung",
    },
  },
  objectiveClient: {
    label: "Zielsetzung Mandantschaft",
    values: {
      fulfillment: "Erfüllung des Vertrags",
      withdrawal: "Rücktritt vom Vertrag",
      replacement: "Neulieferung",
      repair: "Nachbesserung oder Reparatur",
      reduction: "Volle oder teilweise Erstattung",
      compensation: "Schadensersatz",
      careerAndEmployment: "Karriere & Dienstverhältnis",
      moneyAndRefund: "Geld & Erstattung",
      other: "Andere Zielsetzung",
    },
  },
  courtPostalCodeOptions: {
    plaintiff: "Kläger",
    defendant: "Beklagter",
  },
  statementOfClaimDocument: {
    label: "Klageschrift",
  },
  judgementReceivedDate: {
    label: "Eingang Urteil am",
  },
  opposingPartyReference: {
    label: "Internes Aktenzeichen Gegenseite",
    helperText: "z.B. Ticket- oder Vorgangsnummer des Kundenservices",
  },
  nextInstanceRecommendation: {
    label: "Empfehlung Kanzlei nächste Instanz",
    values: {
      appeal: "Rechtsmittel einlegen",
      noAppeal: "Keine Rechtsmittel einlegen",
    },
  },
  nextInstanceDecisionClient: {
    label: "Entscheidung Mandantschaft nächste Instanz",
    values: {
      appeal: "Berufung einlegen",
      noAppeal: "Keine Berufung einlegen",
      checkJudgement: "Empfehlung einholen",
    },
  },
  statementOfClaimSentDate: {
    label: "Klage eingereicht am",
  },
  promulgationOfJudgementDate: {
    label: "Verkündungsdatum des Urteils",
  },
  judgementEebSentDate: {
    label: "EB-Datum Urteil",
  },
  statementOfClaimFiledDate: {
    label: "Klage erhalten am",
  },
  statementOfDefenseDocument: {
    label: "Klageerwiderung eingereicht am",
  },
  statementOfDefenseSentDate: {
    label: "Klageerwiderung",
  },
  statementOfDefenseFiledDate: {
    label: "Klageerwiderung erhalten am",
  },
  replicaDocument: {
    label: "Replik",
  },
  replicaSentDate: {
    label: "Replik eingereicht am",
  },
  replicaFiledDate: {
    label: "Replik erhalten am",
  },
  customerLawsuitCompletedApprovalDate: {
    settlement: {
      label: "Zustimmung Mandantschaft zum Vergleich am",
    },
    lawsuitRevocation: {
      label: "Zustimmung Mandantschaft zur Klagerücknahme am",
    },
    lawsuitRevocationBeforeHearing: {
      label: "Zustimmung Mandantschaft zur Klagerücknahme am",
    },
    resolution: {
      label: "Zustimmung Mandantschaft zur Erledigungserklärung am",
    },
    grant: {
      label: "Zustimmung Mandantschaft zur Stattgabe am",
    },
    partialGrant: {
      label: "Zustimmung Mandantschaft zur Teil-Stattgabe am",
    },
    dismissal: {
      label: "Zustimmung Mandantschaft zur Anlehnung am",
    },
    order: {
      label: "Zustimmung Mandantschaft zum Beschluss am",
    },
    //cause the validation cant access form values
    label: "Datum Zustimmung Gerichtsverfahrensende",
  },
  lawsuitCompletedReason: {
    label: "Rechtsstreit beendet durch",
    values: {
      courtDecision: "Urteil",
      settlement: "Vergleich",
      lawsuitRevocation: "Klagerücknahme",
      lawsuitRevocationBeforeHearing: "Klagerücknahme vor Termin",
      resolution: "Erledigung",
      defaultJudgement: "Versäumnisurteil",
      judgementAppeal: "Einlegung von Rechtsmitteln",
      judgementByConfession: "Anerkenntnisurteil",
      courtOrder: "Beschluss vom Gericht ",
      partialGrant: "Teil-Stattgabe",
      dismissal: "Ablehnung",
      grant: "Stattgabe",
      order: "Beschluss",
    },
  },
  lawsuitCompletedDate: {
    label: "Gerichtsverfahren beendet am",
  },
  valueInDisputeExtrajudicialPreliminary: {
    label: "Vorläufiger Streitwert a.g. Verfahren",
  },
  valueInDisputeExtrajudicialFinal: {
    label: "Finaler Streitwert a.g. Verfahren",
  },
  hasExtrajudicialValueInDisputeOverwrite: {
    label: "Gerichtlichen Streitwert für a.g. Rechnung übernehmen",
    values: {
      true: "Ja",
      false: "Nein",
    },
  },
  valueInDisputeJudicialPreliminary: {
    label: "Vorläufiger Streitwert ger. Verfahren",
  },
  valueInDisputeJudicialFinal: {
    label: "Finaler Streitwert ger. Verfahren",
  },
  hasStandardInvoicing: {
    label: "Standardabrechnung?",
    values: {
      true: "Ja",
      false: "Nein",
    },
  },
  subtractExtrajudicialProcessFee: {
    label: "Anrechnung a.g. Verfahren",
    values: {
      true: "Ja",
      false: "Nein",
    },
  },
  netRvgAmount: {
    label: "Gesamtnettobetrag RVG Rechnung",
  },
  costBearingByOpponentExtrajudicial: {
    label: "Gezahlte Kosten a.g. brutto durch Gegner",
  },
  costBearingByOpponentFinalAbsolute: {
    label: "Gezahlte Kosten ger. brutto durch Gegner exkl. GK",
  },
  costBearingByOpponentRelative: {
    label: "Kostenanteil Gegner laut Quotelung im Urteil in %",
  },
  courtCostsFinal: {
    label: "Gerichtskosten laut Beschluss",
  },
  principalClaim: {
    label: "Hauptforderung",
  },
  principalClaimDefaultDate: {
    label: "Hauptforderung im Verzug seit",
  },
  accessoryClaim: {
    label: "Nebenforderung",
  },
  accessoryClaimDefaultDate: {
    label: "Nebenforderung im Verzug seit",
  },
  courtPostalCode: {
    label: "PLZ Gerichtsstand",
  },
  courtReference: {
    label: "Aktenzeichen Gericht",
  },
  responsibleCourt: courtTranslations,
  responsibleAuthority: authorityTranslations,
  authorityReference: {
    label: "Aktenzeichen Behörde",
  },
  caseInSuspension: {
    label: "Fall in Aussetzung",
    values: {
      true: "Ja",
      false: "Nein",
    },
  },
  automaticallyGenerateExtrajudicialLetter: {
    label: "Automatisches Schreiben verwenden?",
  },
  defenseProcessStatus: {
    label: "Status der Forderung gegen Mandantschaft",
    values: {
      none: "Noch nichts erhalten",
      reminder: "Zahlungserinnerung / Mahnung",
      debtCollection: "Inkasso eingeschaltet",
      paymentOrder: "Mahnbescheid erhalten",
      enforcementOrder: "Vollstreckungsbescheid erhalten",
      lawsuit: "Klage erhalten",
    },
  },
  extrajudicialReaction: {
    label: "Reaktion der Gegenseite",
    values: {
      noReaction: "Keine Reaktion",
      fullyAgreed: "Forderung wird vollständig erfüllt/aufgegeben",
      partiallyAgreed: "Forderung wird teilweise erfüllt/aufgegeben",
      disagreed: "Forderung wird nicht erfüllt/aufrechterhalten",
    },
    enforceClaim: {
      label: "Reaktion der Gegenseite",
      values: {
        noReaction: "Keine Reaktion",
        fullyAgreed: "Forderung wird voll erfüllt",
        partiallyAgreed: "Forderung wird teilweise erfüllt",
        disagreed: "Forderung wird nicht erfüllt",
      },
    },
    defendClaim: {
      label: "Reaktion der Gegenseite",
      values: {
        noReaction: "Keine Reaktion",
        fullyAgreed: "Forderung wird vollständig aufgegeben",
        partiallyAgreed: "Forderung wird teilweise aufgegeben",
        disagreed: "Forderung wird aufrechterhalten",
      },
    },
  },
  extrajudicialRecommendation: {
    label: "Empfehlung weiteres Vorgehen",
    values: {
      agreementDone: "Einigung erzielt / Forderung erledigt",
      lawsuit: "Klage einreichen / Klage abwarten",
      insufficientEvidence: "Schlechte Beweislage",
      insufficientChancesOfSuccess: "Schlechte Erfolgsaussicht",
      costBenefitConsiderations: "Schlechtes Kosten-Nutzen-Verhältnis",
      anonymousOpponent: "Gegenseite unklar",
      opponentUnableToPay: "Gegenseite nicht solvent",
      individualText: "Individuelle Empfehlung",
    },
  },
  extrajudicialRecommendationText: {
    label: "Zusatztext Empfehlung",
  },
  finalClaimStatusClient: {
    label: "Stand Forderung aus Sicht Mandantschaft",
    values: {
      fullyAgreed: "Voll erledigt",
      partiallyAgreed: "Teilweise erledigt",
      notAgreed: "Nicht erledigt",
      noReaction: "Keine erledigt",
    },
    enforceClaim: {
      label: "Stand Forderung aus Sicht Mandantschaft",
      values: {
        fullyAgreed: "Voll erfüllt",
        partiallyAgreed: "Teilweise erfüllt",
        notAgreed: "Nicht erfüllt",
        noReaction: "Keine Reaktion",
      },
    },
    defendClaim: {
      label: "Stand Forderung aus Sicht Mandantschaft",
      values: {
        fullyAgreed: "Forderung durch Gegenseite aufgegeben",
        partiallyAgreed: "Forderung durch Gegenseite teilweise aufgegeben",
        notAgreed: "Forderung durch Gegenseite nicht aufgegeben",
        noReaction: "Keine Reaktion",
      },
    },
  },
  finalProcessFeedbackClient: {
    label: "Finale Entscheidung Mandantschaft",
    values: {
      agreement: "Fall abschließen",
      lawsuit: "Gerichtsverfahren",
    },
    enforceClaim: {
      label: "Finale Entscheidung Mandantschaft",
      values: {
        agreement: "Forderung erledigt/zurücknehmen",
        lawsuit: "Forderung einklagen",
      },
    },
    defendClaim: {
      label: "Finale Entscheidung Mandantschaft",
      values: {
        lawsuit: "Forderung nicht erfüllen und Klage abwarten",
        agreement: "Forderung erfüllen und Klage vermeiden",
      },
    },
  },
  extrajudicialReactionReceived: {
    label: "Reaktion der Gegenseite am",
  },
  timeBarredDate: {
    label: "Fall verjährt am",
  },
  extrajudicialCommunicationSent: {
    label: "Schreiben an Gegenseite am",
  },
  extrajudicialCommunicationDeadline: {
    label: "Gesetzte Frist für Gegenseite",
  },
  opposingPartyType: {
    label: "Gegenseite ist",
    values: {
      opposingPartyLegalEntity: "Unternehmen",
      opposingPartyPerson: "Privatperson",
    },
  },
  opposingPartyPerson: personTranslations,
  opposingPartyLegalEntity: {
    organization: {
      label: "Gegenseite",
      ...opposingPartyLegalEntityTranslations,
    },
  },
  objectiveLawFirm: {
    label: "Zielsetzung Kanzlei",
    values: {
      ...objectivesLawFirmValues,
    },
  },
  objectiveLawFirmSecondary: {
    label: "Sekundäre Zielsetzung Kanzlei",
    values: {
      ...objectivesLawFirmValues,
    },
  },
  objectiveLawFirmTertiary: {
    label: "Tertiäre Zielsetzung Kanzlei",
    values: {
      ...objectivesLawFirmValues,
    },
  },
  clientWasMinorAtContractDate: {
    label: "Person minderjährig?",
    values: {
      true: "Ja",
      false: "Nein",
    },
  },
  clientLegalRepresentativeAmount: {
    label: "Anzahl gesetzlicher Vertreter",
    values: {
      1: "Einer",
      2: "Zwei",
    },
  },
  clientLegalRepresentativesAuthorizationType: {
    label: "Art der gesetzlichen Vertretung",
    values: {
      both: "Gesamtvertretung",
      individually: "Einzelvertretung",
    },
  },
  ...legalRepresentativeTranslations,
  claimedAmountClient: {
    label: "Forderungsbetrag Mandantschaft",
  },
  claimedDateClient: {
    label: "Datum Forderungsschreiben Mandant",
  },
  claimedDeadlineClient: {
    label: "Forderungsfrist Mandant",
  },
  clientHasAlreadyClaimed: {
    label: "Mandantschaft hat bereits eingefordert",
    values: {
      true: "Ja",
      false: "Nein",
    },
  },
  claimedAmountLawFirm: {
    label: "Forderungsbetrag",
  },
  prosecutionReference: {
    label: "Aktenzeichen Staatsanwaltschaft",
  },
  contractualPartnerPerson: personTranslations,
  contractualPartnerLegalEntity: {
    organizationEmail: organizationEmailTranslations,
    organization: {
      label: "Gegenseite",
      ...opposingPartyLegalEntityTranslations,
    },
  },
  hasMonitoringBilling: {
    label: "Abrechnung Monitoringgebühr",
    values: {
      true: "Ja",
      false: "Nein",
    },
  },
  affectedPartyType: {
    label: "Vertragsabschließender laut Mandantschaft",
    values: {
      customer: "Er selbst",
      coinsured: "Mitversicherter",
      unknown: "Unbekannt",
    },
  },
  policeInvolved: {
    label: "Polizei hinzugezogen?",
    values: {
      true: "Ja",
      false: "Nein",
    },
  },
  policeReportReferenceNumber: {
    label: "Aktenzeichen oder Vorgangsnummer",
  },
  policeDepartmentName: {
    label: "Name der Polizeidienststelle",
  },
  paymentOrderDate: {
    label: "Datum des Mahnbescheids",
  },
  enforcementOrderDate: {
    label: "Datum des Vollstreckungsbescheids",
  },
  debtCollectionAgencyReference: {
    label: "Aktenzeichen",
  },
  debtCollectionAgency: {
    organizationEmail: organizationEmailTranslations,
    organization: {
      label: "Inkasso",
      ...organizationTranslation,
    },
  },
  opposingLiabilityInsurancePolicyNumber: {
    label: "Versicherungsnummer",
  },
  opposingLiabilityInsuranceCaseReferenceNumber: {
    label: "Schadennummer",
  },
  opposingLiabilityInsurance: {
    organization: {
      label: "Haftpflichtversicherung Gegenseite",
      ...opposingLiabilityInsuranceTranslation,
    },
  },
  initialClientDescriptionAndObjectives: {
    label: "Kurzbeschreibung Mandantschaft",
  },
  refinementAnswers: {
    label: "Ergänzende Informationen Mandantschaft",
  },
  finalClientDescriptionAndObjectives: {
    label: "Beschreibung der Situation",
  },
};

export default litigationCaseTranslations;
